<div class="data-loading">
  <i class="fal fa-sync fa-spin --fa-animation-duration:2s;"></i>
  <span>{{ 'dashboard:Loading' | i18next }}...</span>
</div>
